module.exports = __webpack_public_path__ + "components/cityspotters-story/static/choose-f63276c7086129f934df3c91063bdcc9.svg";